export default {"src":"/_next/static/media/muthoot.ac2ce950.svg","height":256,"width":389,"blurWidth":0,"blurHeight":0};